import { create } from "zustand"

import type { ChatSlice } from "./slices/chat-slice"

import { createChatSlice } from "./slices/chat-slice"
import { createNamespacedStore } from "./store-factory"

type TenderStreamingSlice = {
  isStreaming: boolean
  setIsStreaming: (streaming: boolean) => void
  abortStreaming: (() => void) | null
  setAbortStreaming: (fn: (() => void) | null) => void
}

type TenderChatStoreState = ChatSlice & TenderStreamingSlice

function createTenderChatStoreInstance() {
  return create<TenderChatStoreState>()((set, get, api) => ({
    ...createChatSlice(set as Parameters<typeof createChatSlice>[0], get, api),
    isStreaming: false,
    setIsStreaming: (streaming) => set({ isStreaming: streaming }),
    abortStreaming: null,
    setAbortStreaming: (fn) => set({ abortStreaming: fn }),
  }))
}

// Returns a namespaced store instance scoped to a specific tender case ID.
export function useTenderChatStore(caseId: string) {
  return createNamespacedStore("tender-chat", caseId, createTenderChatStoreInstance)
}
